export default "__VITE_ASSET__1b67895b__"